import { CreativeType as KaizenIdCreativeType, CreativeTypeKey } from '@kaizenplatform/kaizen-offer-entity';

class CreativeType extends KaizenIdCreativeType {
  constructor({ key, name }: Pick<KaizenIdCreativeType, 'key' | 'name'>) {
    super({ key, name });
  }

  public static fromJSON = (value: any) => {
    const { key: _key, name } = Object.assign({}, value);

    const key = deserializeToCreativeTypeKey(_key);

    if (typeof name !== 'string') throw new TypeError('.name must be a string');

    return new CreativeType({
      key,
      name,
    });
  };
}

const deserializeToCreativeTypeKey = (str: string): CreativeTypeKey => {
  if (Object.keys(CreativeTypeKey).indexOf(str) === -1) {
    throw new Error(`str must be a one of ${Object.keys(CreativeTypeKey).join(', ')}`);
  }

  return str as CreativeTypeKey;
};

export default CreativeType;
